import { pathToUrl } from '../../helpers/urls';

export interface Species {
  id: number;
  aggregate_id: null;
  gear_id: number;
  location_id: number;
  measurement_id: number;
  parent_id: number;
  specie_shape_id: number;
  fish_id: number;
  aggregate_limit: null | number;
  bag_limit: number;
  vessel_limit: number | null;
  trophy_limit: number | null;
  min_size: number | null;
  max_size: number | null;
  trophy_size: number | null;
  location_rank: number;
  prohibited: number;
  freshwater: number;
  saltwater: number;
  species_report_only: number;
  published: number;
  effective: number;
  location_prohibited: number;
  location_freshwater: number;
  location_saltwater: number;
  location_is_top_level: number;
  production: number;
  additional_licenses_required: string;
  aggregate_name: null;
  gear_name: string;
  location_area: string;
  location_name: string;
  location_prohibited_message: string;
  measurement_name: string;
  measurement_abbreviation: string;
  measurement_unit: string;
  measurement_unit_symbol: string;
  species: string;
  shape: string;
  notes: string;
  location_regulation_notes: string;
  gear_description: string;
  measurement_description: string;
  edibility: string;
  synonyms: string[];
  seasons: {
    id: number;
    regulation_id: number;
    starts_at: {
      date: string;
      timezone_type: number;
      timezone: string;
    };
    ends_at: {
      date: string;
      timezone_type: number;
      timezone: string;
    };
    created_at: string;
    updated_at: string;
  }[];
  gigging: number;
  snagging: number;
  spearing: number;
  multiple_hooks: number;
  zero_bag_for_captain: number;
  keep_intact: number;
  effective_at: string;
  prohibitions: {
    id: number;
    label: string;
    name: string;
    description: string;
    type: string;
  }[];
  restrictions: {
    id: number;
    label: string;
    name: string;
    description: string;
    type: string;
  }[];
  requirements: {
    id: number;
    label: string;
    name: string;
    description: string;
    type: string;
  }[];
}

interface Result {
  success: boolean;
  results: Species[];
}

interface Variables {
  fishrulesSpeciesId: number;
  latitude: number;
  longitude: number;
}

export async function getSpeciesAtLocation(
  { fishrulesSpeciesId, latitude, longitude }: Variables,
  signal: AbortSignal,
): Promise<Result> {
  const response = await fetch(pathToUrl('/api/_fishrules/get-species-at-location'), {
    body: JSON.stringify({ latitude, longitude, fishrulesSpeciesId }),
    method: 'POST',
    signal,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
  const json: Result = await response.json();
  return json;
}
